import { NodeType } from '../IBaseNode';
var NearbyAssetNode = /** @class */ (function () {
    function NearbyAssetNode(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.id, id = _c === void 0 ? null : _c, _d = _b.title, title = _d === void 0 ? null : _d, _e = _b.name, name = _e === void 0 ? null : _e, _f = _b.joinKey, joinKey = _f === void 0 ? null : _f, _g = _b.parentJoinKey, parentJoinKey = _g === void 0 ? null : _g, _h = _b.layerId, layerId = _h === void 0 ? null : _h, _j = _b.tableId, tableId = _j === void 0 ? null : _j, _k = _b.description, description = _k === void 0 ? null : _k, _l = _b.templates, templates = _l === void 0 ? null : _l, _m = _b.sources, sources = _m === void 0 ? null : _m, _o = _b.link, link = _o === void 0 ? null : _o, _p = _b.columns, columns = _p === void 0 ? null : _p, _q = _b.columnList, columnList = _q === void 0 ? null : _q, _r = _b.record, record = _r === void 0 ? null : _r;
        this.id = id;
        this.title = title;
        this.name = name;
        this.joinKey = joinKey;
        this.parentJoinKey = parentJoinKey;
        this.layerId = layerId;
        this.tableId = tableId;
        this.description = description;
        this.templates = templates;
        this.sources = sources;
        this.link = link;
        this.columns = columns;
        this.columnList = columnList;
        this.record = record;
    }
    Object.defineProperty(NearbyAssetNode.prototype, "nodeType", {
        get: function () {
            var type = NodeType.Category;
            if (this.layerId) {
                type = NodeType.Layer;
            }
            else if (this.tableId) {
                type = NodeType.Table;
            }
            else if (this.record) {
                if (Array.isArray(this.record)) {
                    type = NodeType.Record;
                }
                else {
                    type = NodeType.Document;
                }
            }
            return type;
        },
        enumerable: true,
        configurable: true
    });
    return NearbyAssetNode;
}());
export { NearbyAssetNode };
